import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelFacebookIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          d="M12.0935 4.78C12.0626 4.74486 12.0247 4.71661 11.9822 4.69709C11.9397 4.67756 11.8936 4.6672 11.8468 4.66667H9.3335V3.72667C9.3335 3.54 9.3735 3.32667 9.6735 3.32667H11.6735C11.7175 3.32956 11.7616 3.32201 11.8021 3.30463C11.8427 3.28725 11.8786 3.26054 11.9068 3.22667C11.9368 3.1971 11.9605 3.16178 11.9766 3.12284C11.9926 3.08389 12.0006 3.04212 12.0002 3V0.333333C12.0002 0.244928 11.965 0.160143 11.9025 0.0976311C11.84 0.035119 11.7552 0 11.6668 0L8.78016 0C5.58016 0 5.3335 2.73333 5.3335 3.56667V4.66667H3.66683C3.57842 4.66667 3.49364 4.70179 3.43113 4.7643C3.36862 4.82681 3.3335 4.91159 3.3335 5V7.66667C3.3335 7.75507 3.36862 7.83986 3.43113 7.90237C3.49364 7.96488 3.57842 8 3.66683 8H5.3335V15.6667C5.3335 15.7551 5.36861 15.8399 5.43113 15.9024C5.49364 15.9649 5.57842 16 5.66683 16H9.00016C9.08857 16 9.17335 15.9649 9.23587 15.9024C9.29838 15.8399 9.3335 15.7551 9.3335 15.6667V8H11.5668C11.6498 8.00042 11.7299 7.96991 11.7915 7.91444C11.8531 7.85896 11.8919 7.78251 11.9002 7.7L12.1735 5.03333C12.1795 4.98782 12.1755 4.94155 12.1617 4.89777C12.1479 4.85399 12.1246 4.81379 12.0935 4.78Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
